export enum CompletionRoutes {
    IDLE = "completionIdle",
    SETTINGS = "completionSettings",
    LOAD_CONTAINER = "completionLoadContainer",
    SIGNIN = "completionLogin",
    CONTAINER_VIEW = "completionContainerView",
}

export enum TestCompletionRoutes {
    IDLE = "testCompletionIdle",
    SETTINGS = "testCompletionSettings",
    LOAD_CONTAINER = "testCompletionLoadContainer",
    SIGNIN = "testCompletionLogin",
    CONTAINER_VIEW = "testCompletionContainerView",
}
